export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'created_at',
    caption: 'Criação',
    dataType: 'date',
    format: 'dd/MM/yyyy HH:mm',
    width: 150
  },
  {
    dataField: 'sequencia',
    caption: 'Sequência',
    width: 80
  },
  {
    dataField: 'tela_descricao',
    caption: 'Tela'
  },
  {
    dataField: 'funcionalidade_descricao',
    caption: 'Funcionalidade'
  },
  {
    dataField: 'nome',
    caption: 'Nome'
  },
  {
    caption: 'Ações',
    cellTemplate: 'acaoCell',
    width: 110
  }
]
